<template>

  <v-text-field
    v-bind="computedProps"
    :placeholder="phtext"
    v-on="computedListeners">
    <template v-slot:append>
      <v-btn @click="onLastMonth" icon color="primary" dark elevation="0" small><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn @click="onThisMonth" icon color="primary" dark elevation="0" small>当月</v-btn>
      <v-btn @click="onNextMonth" icon color="primary" dark elevation="0" small><v-icon>mdi-chevron-right</v-icon></v-btn>
    </template>
  </v-text-field>

</template>
<script>
import controls from '@/rahmen/controls'
import complements from '@/rahmen/complement'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VTextField } from 'vuetify/lib'

/**
 * @file DDv2用セレクトボタン付き年月入力
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [max='']- 許容最大値(デフォルト:2999/12)
 * @vue-prop {String} [min=''] - 許容最小値(デフォルト:2000/01)
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-year-month-box-with-Selector
    label="適用開始年月"
    v-model="ymValue"
    max="2099/12"
    min="2000/01"/>
 */
export default {
  name: 'DdYearMonthBoxWithSelector',
  extends: VTextField,
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 入力可能最大値
     */
    max: String,
    /**
     * 入力可能最小値
     */
    min: String,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String
  },
  data: () => ({
    phtext: '',
    hasFocus: false,
    invalidMessage: '',
    innerValue: '',
    defaultMax: '2999/12',
    defaultMin: '2000/01'
  }),
  created () {
  },
  mounted () {
    const dtl = controls.getInputTypeDetail(controls.InputTypes.YearMonth)
    if (!dtl) { return }
    this.phtext = 'yyyy/mmで入力'
    this.invalidMessage = this.errorMessages
    this.innerValue = this.value
  },
  watch: {
    value: function (n, o) {
      this.innerValue = n
    }
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        maxlength: this.length,
        class: this.required ? ' required-item' : this.class,
        hideDetails: 'auto',
        outlined: !this.isReadonly,
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== undefined
    }
  },
  methods: {
    onBlur: function (e) {
      this.complement()
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
      }
    },
    onFocus: function (e) {
      const val = this.lazyValue
      this.innerValue = val.split('/').join('')

      const elem = this.$el.querySelector('input')
      console.log('DdYearMonthBoxWithSelector.onFocus', elem)
      this.$nextTick().then(() => {
        if (elem) { elem.select() }
        this.$emit('focus', e)
      })
    },
    complement: function () {
      const val = complements.parseYearMonth(this.lazyValue)
      this.$set(this, 'innerValue', val)
      this.$emit('input', val)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        max: this.max === undefined ? this.defaultMax : this.max,
        min: this.min === undefined ? this.defaultMin : this.min
      }

      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(controls.InputTypes.YearMonth)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    },
    onLastMonth: function (e) {
      if (this.value === '') { return }
      this.innerValue = this.monthAdd(-1, this.value + '/01')
      this.$emit('settingSeikyuYm', this.innerValue)
    },
    onThisMonth: function (e) {
      var today = new Date()
      this.innerValue = ('000' + today.getFullYear()).slice(-4) + '/' + ('0' + (today.getMonth() + 1)).slice(-2)
      this.$emit('settingSeikyuYm', this.innerValue)
    },
    onNextMonth: function (e) {
      if (this.value === '') { return }
      this.innerValue = this.monthAdd(1, this.value + '/01')
      this.$emit('settingSeikyuYm', this.innerValue)
    },
    monthAdd: function (num, date) {
      if (typeof date === 'string') {
        var converted = Date.parse(date)
        var myDate = new Date(converted)
        if (isNaN(myDate)) {
          var arys = date.split('/')
          myDate = new Date(arys[0], --arys[1], arys[2])
        }
        date = myDate
      }
      var resultDate = new Date(date.getTime())
      resultDate.setMonth(date.getMonth() + num)
      if (date.getDate() > resultDate.getDate()) {
        resultDate.setDate(0)
      }

      return ('000' + resultDate.getFullYear()).slice(-4) + '/' + ('0' + (resultDate.getMonth() + 1)).slice(-2)
    }

  }
}
</script>
<style scoped>
</style>
